// @flow

// ACtivity Event: Первый в течении дня доступ
export const ACE_FIRST_ACCESS: 'firstAccess' = 'firstAccess'; // eslint-disable-line
